/* Guides and advice (blog direction B, Oct 2026). Loaded by the waltons-blog-* and
   waltons-article-* sections only. Several sections print the tag, so it runs once.
   - Keeps ?view= on links between advice pages while the templates are previewed.
   - More topics dropdown: closes on an outside click or Escape, stays on screen.
   - Article: wraps tables so they scroll sideways, turns a Frequently Asked Questions
     section of H3 questions into an accordion, builds the "In this guide" list from the
     H2s (adding ids where missing), marks the current section, can caption single images
     from their alt text, and copies the article link.
   The article HTML itself is never rewritten beyond these additions. */
(function () {
  if (window.waltonsAdvice) return;
  window.waltonsAdvice = true;

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  /* ---------- Keep ?view= on advice links (template previews) ---------- */
  function keepView() {
    var view = null;
    try { view = new URLSearchParams(window.location.search).get('view'); } catch (e) { return; }
    if (!view) return;
    document.querySelectorAll('[data-wad-root] a[href]').forEach(function (a) {
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#') return;
      var u;
      try { u = new URL(href, window.location.href); } catch (e) { return; }
      if (u.origin !== window.location.origin || u.pathname.indexOf('/blogs/') !== 0) return;
      if (u.searchParams.has('view')) return;
      u.searchParams.set('view', view);
      a.setAttribute('href', u.pathname + u.search + u.hash);
    });
  }

  /* ---------- More topics dropdown ---------- */
  function moreTopics() {
    var menus = document.querySelectorAll('[data-wad-more]');
    if (!menus.length) return;
    function place(d) {
      var panel = d.querySelector('.wad-more__panel');
      if (!panel) return;
      panel.style.left = '';
      if (window.innerWidth < 750) return;
      var r = panel.getBoundingClientRect();
      var over = r.right - (document.documentElement.clientWidth - 16);
      if (over > 0) panel.style.left = (-over) + 'px';
    }
    menus.forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) place(d); });
    });
    document.addEventListener('click', function (e) {
      menus.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      menus.forEach(function (d) {
        if (!d.open) return;
        d.open = false;
        var s = d.querySelector('summary');
        if (s) s.focus();
      });
    });
  }

  /* ---------- Article ---------- */
  // The heading of a contents list typed into the article ("Skip to Section", "Contents").
  var listHead = /^(skip to (a )?section|jump to (a )?section|(table of )?contents|in this (guide|article))\s*:?$/i;
  // A short heading or bold line over a typed list of steps ("Shed security - at a glance").
  // It only counts when a list of jump links follows, so it is never left out on its own.
  var glanceHead = /\bat a glance\b/i;

  function slug(text) {
    return (text || '').toLowerCase().replace(/&/g, ' and ').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 64) || 'section';
  }

  // Tables scroll sideways in their own box. Tables that only lay out images (no text in
  // any cell) keep their natural size, with no border, hint or minimum width. Tables
  // inside another table are left alone.
  function wrapTables(content, root) {
    var hintText = root.getAttribute('data-swipe') || '';
    content.querySelectorAll('table').forEach(function (t) {
      if (t.parentElement && t.parentElement.closest('table')) return;
      var text = (t.textContent || '').replace(/\u00a0/g, ' ').trim();
      var imagesOnly = text === '' && !!t.querySelector('img');
      var box = t.parentElement;
      if (!box.classList.contains('wad-table')) {
        box = document.createElement('div');
        box.className = 'wad-table';
        t.parentNode.insertBefore(box, t);
        box.appendChild(t);
      }
      if (imagesOnly) {
        box.classList.add('wad-table--images');
        return;
      }
      var cols = 0;
      Array.prototype.slice.call(t.rows, 0, 3).forEach(function (row) {
        var n = 0;
        Array.prototype.forEach.call(row.cells, function (c) { n += c.colSpan || 1; });
        if (n > cols) cols = n;
      });
      t.style.setProperty('--wad-cols', cols || 2);
      var cap = t.querySelector('caption');
      box.setAttribute('role', 'region');
      box.setAttribute('aria-label', cap && cap.textContent.trim() ? cap.textContent.trim() : 'Table');
      box.tabIndex = 0;
      if (!hintText) return;
      var outer = box.parentElement && box.parentElement.classList.contains('responsive-table') ? box.parentElement : box;
      var hint = document.createElement('p');
      hint.className = 'wad-table__hint';
      hint.textContent = hintText;
      outer.parentNode.insertBefore(hint, outer);
      var check = function () { hint.classList.toggle('is-on', box.scrollWidth > box.clientWidth + 4); };
      check();
      if ('ResizeObserver' in window) new ResizeObserver(check).observe(box);
      else window.addEventListener('resize', check);
    });
  }

  function faqAccordion(content) {
    var heads = content.querySelectorAll('h2');
    var faqHead = null;
    Array.prototype.some.call(heads, function (h) {
      if (/frequently asked|^\s*faqs?\b/i.test(h.textContent || '')) { faqHead = h; return true; }
      return false;
    });
    if (!faqHead) return;
    var nodes = [];
    var n = faqHead.nextElementSibling;
    while (n && n.tagName !== 'H2') { nodes.push(n); n = n.nextElementSibling; }
    var questions = nodes.filter(function (el) { return el.tagName === 'H3' && (el.textContent || '').trim(); });
    if (questions.length < 2) return;

    var wrap = document.createElement('div');
    wrap.className = 'wad-faq';
    questions[0].parentNode.insertBefore(wrap, questions[0]);
    var item = null;
    var answer = null;
    var started = false;
    nodes.forEach(function (el) {
      if (el.tagName === 'H3' && questions.indexOf(el) !== -1) {
        started = true;
        item = document.createElement('details');
        item.className = 'wad-faq__item';
        if (!wrap.children.length) item.open = true;
        var q = document.createElement('summary');
        q.className = 'wad-faq__q';
        el.classList.add('wad-faq__h');
        q.appendChild(el);
        q.insertAdjacentHTML('beforeend', '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>');
        answer = document.createElement('div');
        answer.className = 'wad-faq__a';
        item.appendChild(q);
        item.appendChild(answer);
        wrap.appendChild(item);
      } else if (started && answer) {
        answer.appendChild(el);
      }
    });
  }

  function captions(content) {
    var title = (document.querySelector('.wad-ahead__title') || {}).textContent || '';
    title = title.trim().toLowerCase();
    var bad = /\.(jpe?g|png|gif|webp|avif|svg)$|^(img|dsc|image|photo|screenshot|untitled)[\s_-]*\d|_/i;
    content.querySelectorAll('img[alt]').forEach(function (img) {
      if (img.closest('figure, a, table, .wad-faq')) return;
      var alt = (img.getAttribute('alt') || '').replace(/\s+/g, ' ').trim();
      if (alt.length < 16 || alt.length > 140 || alt.split(' ').length < 3 || bad.test(alt)) return;
      if (alt.toLowerCase() === title) return;
      var box = img.parentElement;
      if (!box || box === content || !/^(P|DIV|SPAN|CENTER)$/.test(box.tagName)) return;
      if (box.querySelectorAll('img').length !== 1) return;
      if ((box.textContent || '').replace(/\u00a0/g, ' ').trim() !== '') return;
      var next = box.nextElementSibling;
      if (next) {
        var nt = (next.textContent || '').trim();
        if (/^(image|photo|picture|credit)\s*:/i.test(nt) || nt.toLowerCase().indexOf(alt.toLowerCase()) === 0) return;
        if (/^(EM|I|SMALL)$/.test(next.tagName) || next.matches('p[style*="padding-left"]')) return;
      }
      var add = function () {
        if (img.naturalWidth && img.naturalWidth < 300) return;
        if (box.querySelector('.wad-cap')) return;
        var cap = document.createElement('span');
        cap.className = 'wad-cap';
        cap.textContent = alt;
        box.appendChild(cap);
      };
      if (img.complete && img.naturalWidth) add();
      else img.addEventListener('load', add, { once: true });
    });
  }

  function contents(root, content) {
    var rail = root.querySelector('[data-wad-toc]');
    var phone = root.querySelector('[data-wad-toc-m]');
    var phoneList = root.querySelector('[data-wad-toc-m-list]');
    var count = root.querySelector('[data-wad-toc-count]');
    var bar = root.querySelector('[data-wad-progress]');
    var min = parseInt(root.getAttribute('data-toc-min'), 10) || 3;
    var used = {};
    document.querySelectorAll('[id]').forEach(function (el) { used[el.id] = true; });

    var heads = Array.prototype.filter.call(content.querySelectorAll('h2'), function (h) {
      var t = (h.textContent || '').replace(/\u00a0/g, ' ').trim();
      return t !== '' && !listHead.test(t) && !h.closest('.wad-faq__a');
    });
    heads.forEach(function (h) {
      if (h.id) return;
      var base = slug(h.textContent);
      var id = base;
      var i = 2;
      while (used[id]) { id = base + '-' + i; i += 1; }
      used[id] = true;
      h.id = id;
    });

    if (!rail && !phoneList) return;
    if (heads.length >= min) {
      hideHandmade(content);
      // A heading hidden with its typed list ("Shed security - at a glance") is not
      // listed either.
      heads = heads.filter(function (h) { return !h.classList.contains('wad-handmade-toc'); });
    }
    if (heads.length < min) {
      // Fewer real sections than the page counted: drop the list and its column, so the
      // reading column lines up with the header and the share buttons show at the end.
      // Any typed list shows again, as there is no built one.
      content.querySelectorAll('.wad-handmade-toc').forEach(function (el) { el.classList.remove('wad-handmade-toc'); });
      var nav = root.querySelector('.wad-toc');
      if (nav) nav.remove();
      if (phone) phone.remove();
      root.classList.remove('has-toc');
      return;
    }

    var links = [];
    var phoneLinks = [];
    heads.forEach(function (h) {
      var text = (h.textContent || '').replace(/\s+/g, ' ').trim();
      if (rail) {
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = text;
        li.appendChild(a);
        rail.appendChild(li);
        links.push(a);
      }
      if (phoneList) {
        var li2 = document.createElement('li');
        var a2 = document.createElement('a');
        a2.href = '#' + h.id;
        a2.textContent = text;
        li2.appendChild(a2);
        phoneList.appendChild(li2);
        phoneLinks.push(a2);
      }
    });
    if (count) count.textContent = heads.length + (heads.length === 1 ? ' section' : ' sections');
    root.classList.add('wad-toc-ready');
    var tin = root.querySelector('.wad-toc__in');
    if (phone) {
      phoneLinks.forEach(function (a) {
        a.addEventListener('click', function () { phone.open = false; });
      });
    }

    function mark(list, current) {
      list.forEach(function (a, i) {
        a.classList.toggle('is-active', i === current);
        if (i === current) a.setAttribute('aria-current', 'true');
        else a.removeAttribute('aria-current');
      });
    }
    // On short windows the rail scrolls inside itself: keep the current section in the
    // middle of it and fade the bottom edge while more of the list is below.
    function railView(a) {
      if (!tin) return;
      var over = tin.scrollHeight > tin.clientHeight + 2;
      if (over && a) {
        var top = a.getBoundingClientRect().top - tin.getBoundingClientRect().top + tin.scrollTop;
        tin.scrollTop = Math.max(0, top - tin.clientHeight / 2 + a.offsetHeight / 2);
      }
      tin.classList.toggle('is-more', over && tin.scrollTop + tin.clientHeight < tin.scrollHeight - 4);
    }
    if (tin) tin.addEventListener('scroll', function () { railView(null); }, { passive: true });

    var frame = 0;
    var last = -1;
    function update() {
      frame = 0;
      var line = window.innerHeight * 0.3;
      var current = 0;
      heads.forEach(function (h, i) { if (h.getBoundingClientRect().top <= line) current = i; });
      if (current !== last) {
        last = current;
        mark(links, current);
        mark(phoneLinks, current);
        railView(links[current]);
      }
      if (bar) {
        var r = content.getBoundingClientRect();
        var p = Math.min(1, Math.max(0, (window.innerHeight * 0.4 - r.top) / Math.max(1, r.height)));
        bar.style.width = (p * 100).toFixed(1) + '%';
      }
    }
    function onScroll() { if (!frame) frame = window.requestAnimationFrame(update); }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { last = -1; onScroll(); });
    update();
  }

  // A contents list typed into the article repeats the one built here, so while the built
  // one shows it is hidden (not removed): a list, or a nav holding one, whose links mostly
  // jump to headings on this page, under a "Skip to Section", "Contents" or "... at a
  // glance" heading, or a nav after a lead-in sentence that ends with a colon. A link
  // jumps when its target is on this page by id or as an old <a name> anchor, or when it
  // is written out in full with this page's own address and a #part.
  function jumpsHere(a) {
    var href = a.getAttribute('href') || '';
    var at = href.indexOf('#');
    if (at === -1) return false;
    var id = href.slice(at + 1);
    if (!id) return false;
    try { id = decodeURIComponent(id); } catch (e) { return false; }
    if (document.getElementById(id)) return true;
    if (Array.prototype.some.call(document.getElementsByName(id), function (el) { return el.tagName === 'A'; })) return true;
    if (at === 0) return false;
    try {
      var u = new URL(href, window.location.href);
      return u.pathname.replace(/\/$/, '') === window.location.pathname.replace(/\/$/, '');
    } catch (e) { return false; }
  }

  function hideHandmade(content) {
    content.querySelectorAll('ul, ol').forEach(function (list) {
      var all = list.querySelectorAll('a');
      var jumps = Array.prototype.filter.call(all, jumpsHere);
      if (jumps.length < 3 || jumps.length < all.length * 0.8) return;
      var nav = list.closest('nav');
      var box = nav && content.contains(nav) ? nav : list;
      var prev = box.previousElementSibling;
      var prevText = prev ? (prev.textContent || '').replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim() : '';
      var label = prev && listHead.test(prevText) ? prev : null;
      if (!label && prev && /^(H[2-6]|P)$/.test(prev.tagName) && glanceHead.test(prevText) && prevText.split(' ').length <= 12) label = prev;
      if (!label && box === list) return;
      // A short lead-in that only introduces the list ("...every aspect of your new shed
      // including:") would end on nothing, so it goes with the list.
      if (!label && prev && prev.tagName === 'P' && /:$/.test(prevText) && prevText.split(' ').length <= 40) label = prev;
      box.classList.add('wad-handmade-toc');
      if (label) label.classList.add('wad-handmade-toc');
    });
  }

  // A link to a part of the article (a heading id, or an old <a name> anchor) is jumped to
  // again here. The browser's own jump on load can come before the contents list adds
  // heading ids, the FAQ opens or a typed list is hidden, and before theme.js has measured
  // the sticky header (it sets --header-height in an animation frame, which a tab opened in
  // the background only runs once it is shown). So this jump waits for the header's height,
  // and the CSS scroll margin then clears it. Skipped once the reader has scrolled.
  function jumpToHash() {
    var hash = window.location.hash;
    if (!hash || hash.length < 2) return;
    var id;
    try { id = decodeURIComponent(hash.slice(1)); } catch (e) { return; }
    var el = document.getElementById(id) || Array.prototype.filter.call(document.getElementsByName(id), function (a) { return a.tagName === 'A'; })[0];
    if (!el) return;
    var item = el.closest('details');
    if (item && !item.open) item.open = true;
    // Back, forward and reload put the reader back where they were, so that place stands.
    var nav = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
    if (nav && (nav.type === 'back_forward' || nav.type === 'reload')) return;
    // An empty anchor inside a heading sits on its baseline, so the heading is the target.
    if (el.tagName === 'A') el = el.closest('h2, h3') || el;
    var moved = false;
    var stop = function () { moved = true; };
    ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (type) {
      window.addEventListener(type, stop, { once: true, passive: true });
    });
    var frames = 0;
    function go() {
      if (moved) return;
      var head = parseFloat(window.getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
      // Gives up waiting after about a second, and the CSS floor stands in for the header.
      if (!head && frames < 60) {
        frames += 1;
        window.requestAnimationFrame(go);
        return;
      }
      el.scrollIntoView({ block: 'start' });
    }
    window.setTimeout(go, 60);
  }

  function copyLinks() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wad-copy]');
      if (!btn) return;
      var url = btn.getAttribute('data-wad-copy');
      var root = btn.closest('[data-wad-root]');
      var msg = (root && root.getAttribute('data-copied')) || 'Link copied';
      var done = function () {
        var holder = btn.parentElement;
        var old = holder.querySelector('.wad-share__status');
        if (old) old.remove();
        var s = document.createElement('span');
        s.className = 'wad-share__status';
        s.setAttribute('role', 'status');
        s.textContent = msg;
        holder.appendChild(s);
        window.setTimeout(function () { s.remove(); }, 2200);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(done, function () {});
    });
  }

  ready(function () {
    keepView();
    moreTopics();
    copyLinks();
    var root = document.querySelector('[data-wad-article]');
    var content = root && root.querySelector('[data-wad-content]');
    if (!content) return;
    wrapTables(content, root);
    if (root.getAttribute('data-faq') === 'true') faqAccordion(content);
    contents(root, content);
    if (root.getAttribute('data-captions') === 'true') captions(content);
    jumpToHash();
  });
})();
